<div class="configuration-planning-trimesters-view-part">

	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="trimesters()"></grid-content>

</div>